/**
 * Determine if a value is a non-empty array
 */
export const isNonEmptyArray = (value: unknown): value is unknown[] => {
  return Array.isArray(value) && value.length > 0;
};
